module.exports = __webpack_public_path__ + "static/media/reset.5079dba8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/login/assets/illustrations/reset.svg
// module id = 1605
// module chunks = 0